module.exports = __webpack_public_path__ + "media/public/fonts/QanelasBold/QanelasBold-f3a67fd4e1f07e34ab654942a1c8a9c3.woff";